import { render, staticRenderFns } from "./poster-conf.vue?vue&type=template&id=2e23dc21&scoped=true&"
import script from "./poster-conf.vue?vue&type=script&lang=js&"
export * from "./poster-conf.vue?vue&type=script&lang=js&"
import style0 from "./poster-conf.vue?vue&type=style&index=0&id=2e23dc21&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e23dc21",
  null
  
)

export default component.exports